import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoutes from "./routes/protected-routes";
import PublicRoutes from "./routes/public-routes";
import { protectedRoutes, publicRoutes } from "./routes/routes";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/main.scss";
import "antd/dist/antd";
import NotFound from "./components/not-found";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="*" element={<NotFound />} />

        <Route path="/" element={<ProtectedRoutes />}>
          {protectedRoutes.map((route) => {
            return (
              <>
                <Route path={route.path} element={route.component} />
              </>
            );
          })}
        </Route>

        {publicRoutes.map((route) => {
          return (
            <Route path={route.path} element={<PublicRoutes />}>
              <Route path={`/${route.path}`} element={route.component} />
            </Route>
          );
        })}
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Router>
  );
}

export default App;
